import React from 'react';

import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';

import { LoadingSkeleton } from '@townsquare/loading-skeleton';

import { AppsGrid } from '../AppsGrid';

const SiteBlockLoadingSkeleton = () => {
	return (
		<Stack space="space.200">
			<LoadingSkeleton width="10%" height="16px" />
			<AppsGrid>
				<LoadingSkeleton width="100%" height="64px" />
				<LoadingSkeleton width="100%" height="64px" />
				<LoadingSkeleton width="100%" height="64px" />
				<LoadingSkeleton width="100%" height="64px" />
				<LoadingSkeleton width="100%" height="64px" />
				<LoadingSkeleton width="100%" height="64px" />
				<LoadingSkeleton width="100%" height="64px" />
				<LoadingSkeleton width="100%" height="64px" />
			</AppsGrid>
		</Stack>
	);
};

export const YourAppsPageSitesLoadingSkeleton = () => {
	return (
		<Stack space="space.200">
			<SiteBlockLoadingSkeleton />
			<SiteBlockLoadingSkeleton />
		</Stack>
	);
};

export const YourAppsPageLoadingSkeleton = () => {
	return (
		<Stack space="space.200">
			<Inline space="space.200" spread="space-between" alignBlock="center">
				<LoadingSkeleton width="79px" height="20px" />
				<LoadingSkeleton width="120px" height="22px" />
			</Inline>
			<SiteBlockLoadingSkeleton />
			<SiteBlockLoadingSkeleton />
		</Stack>
	);
};
